import numeral from "numeral";

export const formatSolNFTPrice = (solPriceUSD: number | null): string => {
  if (solPriceUSD === null) {
    return "--";
  }
  const isLargeValue = solPriceUSD > 1000;
  const isIntegerValue = solPriceUSD % 1 === 0;

  if (isLargeValue || isIntegerValue) {
    const value = numeral(solPriceUSD).format("0,0[.]00");
    return value === "0" ? "--" : value;
  } else {
    let result = solPriceUSD.toPrecision(4);
    while (result.endsWith("0")) {
      result = result.slice(0, result.length - 1);
    }
    if (result.endsWith(".")) {
      result = result.slice(0, result.length - 1);
    }
    return result;
  }
};
